import clsx from 'clsx'

import { PagebuilderSectionTextGroup } from '../types'

import Description from './Description'
import Heading from './Heading'

import styles from './TextGroup.module.scss'

interface TextGroupProps {
  textGroup?: PagebuilderSectionTextGroup
  className?: string
}

const TextGroup = ({ textGroup, className }: TextGroupProps) => {
  if (!textGroup?.heading && !textGroup?.description) return null

  return (
    <div className={clsx(styles.wrapper, className)}>
      {textGroup.heading && <Heading heading={textGroup.heading} />}
      {textGroup.description && (
        <Description description={textGroup.description} />
      )}
    </div>
  )
}

export default TextGroup
